import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function ProgressOthersUnit() {
    return (
        <SettingsMetaData propertyName={"UnitOthers"} viewPropertyName={"Unit"} />
      );
}

export default ProgressOthersUnit
